// depends-on: Bootstrap
// depends-on: efw.links.js???
// DB101 Hub chat integration.
(function ($) {
    const _developmentStage = function () {
        return (/^mn.hb101.org$|^mn.db101.org$/i).test(window.location.hostname) ? 'public' : 'staging';
    };

    var isMessengerReady = false,
        isMessagingServiceReady = false,
        isCleared = false,
        isClearing = false,
        isUserOpen = false;

    const Cookies = require('js-cookie'),
        _ = require('lodash'),
        SESSION_COOKIE = 'hcs_27',
        SESSION_TIMEOUT = 10,   // minutes
        _cookieTimeout = function () {
            return new Date(new Date().getTime() + SESSION_TIMEOUT * 60 * 1000);
        },
        _encodeCookieValue = function (options) {
            return btoa(new Date().toString() + options.deploymentId);
        },
        _checkCookieValue = function (options) {
            try {
                const val = Cookie.get(SESSION_COOKIE);
                return val && atob(val).indexOf(options.deploymentId) > 0;
            } catch (ex) {
                return false;   // bad base64 value
            }
        },
        _setSessionCookie = function (options) {
            Cookies.set(SESSION_COOKIE, _encodeCookieValue(options), { expires: _cookieTimeout() });
        },
        _clearSessionCookie = function () {
            console.log("clear session cookie");
            Cookies.remove(SESSION_COOKIE);
        },
        // Do we have a live cookie set on an earlier page?
        _isCurrentSession = function (options) {
            return _checkCookieValue(options);
        }

    // Call the IsChatOnline API; return an async boolean result
    const _isChatOnline = async function (options) {
        var $opts = options,
            $url = window.location.href,
            $online = false,
            chatOverride = false;

        // get chatOverride querystring parameter. Don't crash on old browsers.
        try {
            const searchParams = new URLSearchParams(window.location.search);
            chatOverride = (/true/i).test(searchParams.get('chatoverride'));
        } catch (e) {
            // continue.
        }

        const apiEndpoint = $opts.service + (chatOverride ? '?chat_override=true' : '');    // spelled differently than our own override

        // Don't crash on old browsers
        if (!window.fetch) {
            return false;
        }

        // fetch api results.
        const response = await fetch(apiEndpoint);

        if (!response.ok) {
            console.warn(`Error at API endpoint: ${response.status} | ${response.statusText}`);
            return false;   // don't throw, just signal not online.
        }

        // parse the result.
        var result = await response.text();
        console.log('hubChat: ' + result);    // API returns string 'True' or 'False'
        $online = (/true/i).test(result);     // boolean true/false

        return $online;
    };

    // This is a requirement to clear data for privacy reasons. Chat history will be cleared 
    async function clearHistoricData() {
        isCleared = true;   // only do this once per page load.
        _clearSessionCookie();

        if (!isMessagingServiceReady) {
            console.warn("MessagingService not ready. Cannot clear chat data.");
            return false;
        }
        
        console.log("Clearing chat data");
        Genesys("command", "MessagingService.clearConversation");

        return true;
    };

    const clearHistoricDataOnce = _.once(clearHistoricData); // just need to do this once per page load.

    // open the chat.
    async function openChat() {
        if (!isMessengerReady) {
            console.warn("Messenger not ready. Cannot open chat.");;
            return false;
        }
        Genesys('command', 'Messenger.open');
        console.log("Opening chat");
        return true;
    };

    async function closeChat() {
        if (!isMessengerReady) {
            console.warn("Messenger not ready. Cannot close chat.");;
            return false;
        }
        Genesys('command', 'Messenger.close');
        console.log("Closing chat");
        return true;
    };

    // ensure chat is visible.
    async function showChat() {
        $('#genesys-messenger').css('display', 'block');
        console.log("Showing chat");
        return true;
    };

    // ensure chat is not visible.
    async function hideChat() {
        $('#genesys-messenger').css('display', 'none');
        console.log("Hiding chat");
        return true;
    };

    // Clear historic data and open a new chat.
    async function clearAndOpenChat() {
        console.log("clearAndOpenChat");
        let success = success && await hideChat(); // hide while clearing and opening new chat.
        success = await clearHistoricDataOnce();    // just need to do this once per page load.
        success = success && await closeChat();  // ensure closed first.
        success = success && await openChat();   // ...otherwise the open command is ignored.
        success = success && await showChat();
        return success;
    };

    const _installGenesysHandlers = async function (options) {
        console.log('Calling _installGenesysHandlers'); 
        async function handleConversationDisconnected({ data }) {
            console.log("handleConversationDisconnected");
            await _clearSessionCookie();  // whenever conversation ends, clear data.
        }
        async function handleConversationCleared({ data }) {
            console.log("handleConversationCleared");
            await _clearSessionCookie();// whenever conversation cleared, clear data.
        }

        function handleMessagingServiceReady() {
            console.log("handleMessagingServiceReady");
            isMessagingServiceReady = true;
            Genesys("subscribe", "MessagingService.conversationDisconnected", handleConversationDisconnected);
            Genesys("subscribe", "MessagingService.conversationCleared", handleConversationCleared);
            Genesys("subscribe", "MessagingService.messagesReceived", function ({ data }) {
                console.log("messagesReceived");
                data.messages.forEach(message => {
                    if (message.direction === 'Inbound' && message.type === 'Text') {
                        _setSessionCookie(options); // note session in progress.
                    }
                });
            });

            // defer this subscription until MessagingService is ready.
            Genesys("subscribe", "Messenger.opened", async function ({ data }) {
                if (isClearing) {
                    return; // avoid reentrancy.
                }

                console.log("Messenger.opened");

                let success = true;
                if (!_isCurrentSession(options) && !isCleared) { // new session, clear out old data first.
                    isClearing = true;
                    if (isUserOpen) {
                        success = await clearAndOpenChat();
                    } else {
                        // just clear the data, don't open the chat.
                        success = await clearHistoricDataOnce();
                    }
                    isClearing = false;
                }
                else {
                    success = await showChat();
                }
                return success;
            });
        }

        // Hanlder for click on the chat open button.
        async function handleClick(e) {
            e.preventDefault();
            e.stopPropagation();
            console.log(`on click`);
            isUserOpen = true;
            await openChat();   // ignore status; maybe alrady open
            await showChat();   // ensure visible
            isUserOpen = false;
        }

        async function handleMessengerReady() {
            console.log("Messenger is ready");
            isMessengerReady = true;

            // adjust UI for online state
            $('.hubArea').efw$hubChat(options);

            // apply click handler
            $('.js-chat-open').off('click').on('click', handleClick);

            Genesys("subscribe", "MessagingService.ready", _.once(handleMessagingServiceReady)); // ensure initialization is called only once

            // open chat right away if we have a session in progress.
            let success = true;
            if (_isCurrentSession(options)) {
                console.log("Detecting current session. Opening chat");
                success = await showChat();
                success = success && await openChat(); 
            }

            return success;
        }

        Genesys("subscribe", "Messenger.ready", _.once(handleMessengerReady)); // ensure initialization is called only once
    };

    // Initialize the Genesys system.
    const _initGenesys = async function (options) {
        console.log("_initGenesys");
        (function (g, e, n, es, ys) {
            g['_genesysJs'] = e;
            g[e] = g[e] || function () {
                (g[e].q = g[e].q || []).push(arguments)
            };
            g[e].t = 1 * new Date();
            g[e].c = es;
            ys = document.createElement('script'); ys.async = 1; ys.src = n; ys.charset = 'utf-8'; document.head.appendChild(ys);
        })(window, 'Genesys', 'https://apps.usw2.pure.cloud/genesys-bootstrap/genesys.min.js', {
            environment: options.environment,
            deploymentId: options.deploymentId,
            debug: options.debug || false
        });
        await Genesys("subscribe", "Database.ready", async function () {
            console.log("Database is ready");
            await Genesys("command", "Database.set", { messaging: { customAttributes: { pageURL: window.location.href, pageTitle: document.title } } });
            await _installGenesysHandlers(options);
        });
    };

    // jQuery plugin to update UI state
    $.fn.efw$hubChat = function (options) {
        // short-curcuit on non-MN sites.
        if (0 == $(this).length) {
            return;
        }

        var $opts = options;    //jQuery.extend({}, jQuery.fn.efw$hubChat.defaults, options),

        // globally fix up hub links
        var $title = $(document).find('title').text().trim(),
            $url = window.location.href,
            $qs = 'page-title=' + encodeURIComponent($title) + '&page-url=' + encodeURIComponent($url);
        
        $('.chat a[href]').each(function () {
            var href = $(this).prop('href');
            if (!(/javascript/i).test(href))    // don't mess with javascript:void(0) URL
                $(this).prop('href', href + (href.indexOf('?') > 0 ? '&' : '?' + $qs)); 
        });
        return this.each(function () {
            var $this = $(this);    // single jQuery element matching outer selector $('.hubArea')

            $('.offline', $this).toggle(!$opts.isOnline);
            $('.online', $this).toggle($opts.isOnline);
        });
    };

    $.fn.efw$hubChat.defaults = {
        staging: {
            service: "https://stage.disabilityhubmn.org/umbraco/api/ChatAvailabilityApi/IsChatOnline",
            environment: 'usw2',
            deploymentId: '049e275f-f11c-48b9-88a7-69c79fcd0c03',
            debug: false
        }, public: {
            service: "https://disabilityhubmn.org/umbraco/api/ChatAvailabilityApi/IsChatOnline",
            environment: 'prod-usw2',
            deploymentId: 'af7e9058-7852-4c1f-b1a5-bf3539a2a482',
            debug: false
        }
    };

    // run when page ready. Note this is now the preferred syntax for $(document).ready().
    $(async function () {
        // only run on MN sites.
        if ($('.hubArea').length > 0) {
            var options = $.fn.efw$hubChat.defaults[_developmentStage()];
            // is chat available?
            options.isOnline = await _isChatOnline(options);

            if (options.isOnline) {
                await _initGenesys(options);
            } else {
                // adjust UI accordingly
                $('.hubArea').efw$hubChat(options);
            }
        }
    });
})(jQuery);